import React from 'react'

const Footer = () => {
    return (
        <footer style={{position:"relative",width:"100%",bottom:"0"}}  id="sticky-footer" className="flex-shrink-0 py-4 bg-dark text-white-50"  >
            <div className="container text-center">
                <small>Made With <g-emoji class="g-emoji" alias="heart" fallback-src="https://github.githubassets.com/images/icons/emoji/unicode/2764.png">
<img class="emoji" alt="heart" height="20" width="20" src="https://github.githubassets.com/images/icons/emoji/unicode/2764.png"/></g-emoji>&nbsp;by Bhanu Pratap Singh</small>
            </div>
        </footer>
    )
}

export default Footer
